import HistoricDataGrid from './HistoricDataGrid';
export { HistoricDataGrid };
export default HistoricDataGrid;
